// src/pdf/makeDocDefinition.js
import pdfMake from "pdfmake/build/pdfmake";
import { fonts, vfs } from "../../fonts/pdfFonts";
import { format } from "date-fns";
import { getKiinteistoSasToken, getMittausProjekti, getNaytteetByProjekti } from "../../api/api";
import { get } from "idb-keyval";
import { getEnergiaTablesByKiinteisto } from "../../api/api";
import { mittausCacheSet, naytteetListSet, naytteetListGet } from "../../utils/mittausCache";
import waativaLogo from '../../assets/images/waativalogoteksilla.png';
import Suomalaista_palvelua from '../../assets/images/Suomalaista_palvelua.png';
import { renderKiinteistoRiskReportPdf } from "./blocksPdf/10vRiskReportPdf";
import { renderCoverPageForm } from "./blocksPdf/RenderCoverPageForm";
import { renderSubsection } from "./blocksPdf/RenderSubsection";
import { renderYmparistoBlock } from "./blocksPdf/RenderYmparistoBlock";
import { renderPohjavesiBlock } from "./blocksPdf/renderPohjavesiBlock";
import { renderTulvariskiBlock } from "./blocksPdf/renderTulvariskiBlock";
import { renderRadonBlock } from "./blocksPdf/renderRadonBlock";
import { renderKuntaRadonBlock } from "./blocksPdf/RenderKuntaRadonBlock";
import { renderAsbestBlock } from "./blocksPdf/RenderAsbestBlock";
import { renderPropertyInfoBlock } from "./blocksPdf/RenderPropertyInfo";
import { renderSignatureBlock } from "./blocksPdf/RenderSignatureBlock";
import { renderToimenpideEhdotukset } from "./blocksPdf/RenderToimenpideEhdotukset";
import { renderToimeksiantajaBlock } from "./blocksPdf/RenderToimeksiantajaBlock";
import { renderSubsectionListBlock } from "./blocksPdf/RenderSubsectionListBlock";
import { renderSubsection2Block } from "./blocksPdf/RenderSubsection2";
import { renderTeamBlock } from "./blocksPdf/RenderTeamBlock";
import { renderTextarea } from "./blocksPdf/RenderTextArea";
import { renderRiskBlock } from "./blocksPdf/RenderRiskBlock";
import { renderLampotilaIndeksiBlock } from "./blocksPdf/RenderLampotilaIndeksiBlock";
import { renderBulletListBlock } from "./blocksPdf/RenderBulletListBlock";
import { renderMapBlock2 } from "./blocksPdf/RenderMapBlock2";
import { renderMaaperaBlock } from "./blocksPdf/renderMaaperaBlock";
import { renderMelutasotBlock } from "./blocksPdf/RenderMelutasotBlock";
import { renderKokonaisKuntoarvio } from "./blocksPdf/RenderKokonaisKuntoarvio";
import { renderEnergiaTableBlock } from "./blocksPdf/renderEnergiaTableBlock";
import { renderPTSBlock } from "./blocksPdf/RenderPTSBlock";
import { renderEnergiaBlock } from "./blocksPdf/RenderEnergiaBlock";
import { renderImageBlock } from "./blocksPdf/RenderImageBlock";
import { renderLexicalTextarea } from "./blocksPdf/RenderLexicalTextarea";
import { renderYhteenvetoToimenpideBlock } from "./blocksPdf/RenderYhteenvetoToimenpideBlock";
import { renderYhteenvetoPtsBlock } from "./blocksPdf/renderYhteenvetoPtsBlock";
import { renderTalousBlock } from "./blocksPdf/renderTalousBlock";
import { renderCapexYhteenveto } from "./blocksPdf/renderCapexYhteenveto";
import { renderToimenpiteetTekstimuodossa } from "./blocksPdf/renderToimenpiteetTekstimuodossa";
import { renderSuositeltavatLisatutkimukset } from "./blocksPdf/RenderSuositeltavatlisatutkimukset" ;
import { hyphenateSync } from "hyphen/fi";
import { renderMapImage } from "./blocksPdf/renderMapImage";
import { renderKuntoTable } from "./blocksPdf/RenderKuntoTable";
import { renderMaaraaikaistarkastusTaulukko } from "./blocksPdf/RenderMaaraaikaistarkastusTaulukko";
import { renderRakennuslupaTaulukko } from "./blocksPdf/RenderRakennuslupaTaulukko";
import { renderVaihtoehdotBlock } from "./blocksPdf/RenderVaihtoehdotBlock";
import { renderKuntoarviolauseBlock } from "./blocksPdf/RenderKuntoarviolauseBlock";
import { renderDynamicPTSBlock } from "./blocksPdf/RenderDynamicPTSBlock";
import {
  renderWeatherBlock
} from "./blocksPdf/renderWeatherBlock";
import {
  PAGE_WIDTH,
  MARGIN_LEFT,
  MARGIN_RIGHT,
  MARGIN_Y,
  MARGIN_BOTTOM,
  CONTENT_WIDTH,
  cmToPt,
  bottomMarginItemGlobal,
  lineHeightGlobal,
  INTEND_GLOBAL,
  fontSizeParagraph,
  headerLeftMarginGlobal,
  headingGreenlineMargin,
  GREEN_HEADER_MARGIN_TOP,
  SECTION_TOP_PAD,
  listStyle,
  paragraphStyle,
  easyReadParagraphStyle
}  from "../utils/pdfConstants";

import { renderTekniikkatauluBlock } from "./blocksPdf/renderTekniikkataulutBlock";
import { renderTutkimustarpeetTauluBlock } from "./blocksPdf/renderTutkimustarpeetTauluBlock";
import { renderPeitepaksuusBlock } from "./blocksPdf/renderPeitepaksuusBlock";
import { renderVetolujuusBlock } from "./blocksPdf/RenderVetolujuusBlock";
import { renderKloridipitoisuusBlock } from "./blocksPdf/RenderKloridipitoisuusBlock";
import { renderPoranayteBlock } from "./blocksPdf/RenderPoranayteBlock";
import { renderOhuthieBlock } from "./blocksPdf/RenderOhuthieBlock";
import { renderPoranayteBlockV2 } from "./blocksPdf/RenderPoranayteBlockV2";
import { renderPeitepaksuusBlockV2 } from "./blocksPdf/RenderPeitepaksuusBlockV2";
import { renderVetolujuusBlockV2 } from "./blocksPdf/RenderVetolujuusBlockV2";
import { renderRappausnayteBlockV2 } from "./blocksPdf/RenderRappausnayteBlockV2";
import { renderOhuthieBlockV2 } from "./blocksPdf/RenderOhuthieBlockV2";
import { renderKloridipitoisuusBlockV2 } from "./blocksPdf/RenderKloridipitoisuusBlockV2";
import { isSentinelSection } from "../../assets/subsectionBlockTemplates";

// Styles that should NOT be hyphenated (headings, cover text)
const NO_HYPHENATE_STYLES = new Set([
  'heading', 'sectionHeading', 'subHeading', 'boldSubHeading',
  'coverTitle', 'coverSubtitle', 'coverDate',
]);

function hyphenStr(str) {
  if (!str || str.length < 8) return str;
  const lastSpace = str.lastIndexOf(' ');
  if (lastSpace === -1) {
    return hyphenateSync(str, { minWordLength: 7, leftmin: 3, rightmin: 4 });
  }
  const body = str.slice(0, lastSpace);
  const tail = str.slice(lastSpace);
  return hyphenateSync(body, { minWordLength: 7, leftmin: 3, rightmin: 4 }) + tail;
}

function hyphenateNode(node, skipText = false) {
  if (!node || typeof node !== 'object') return node;
  if (Array.isArray(node)) return node.map(n => hyphenateNode(n, skipText));

  const mySkip = skipText || NO_HYPHENATE_STYLES.has(node.style) || node.noWrap || node.noHyphenate;
  const out = { ...node };

  if (typeof out.text === 'string' && !mySkip) {
    out.text = hyphenStr(out.text);
  } else if (Array.isArray(out.text)) {
    out.text = out.text.map(item =>
      typeof item === 'string'
        ? (mySkip ? item : hyphenStr(item))
        : hyphenateNode(item, mySkip)
    );
  }

  if (Array.isArray(out.stack))   out.stack   = out.stack.map(n => hyphenateNode(n, false));
  if (Array.isArray(out.columns)) out.columns = out.columns.map(n => hyphenateNode(n, false));
  if (Array.isArray(out.ul))      out.ul      = out.ul.map(n => hyphenateNode(n, false));
  if (Array.isArray(out.ol))      out.ol      = out.ol.map(n => hyphenateNode(n, false));
  if (out.table?.body) {
    out.table = {
      ...out.table,
      body: out.table.body.map(row => row.map(cell => hyphenateNode(cell, false))),
    };
  }

  return out;
}





export default async function MakeDocDefinitionFromJson({ report, rakennusData, assignments, mergedRakennusData, riskidata, isPreview=false, showPreviewImages, groupedToimenpiteet, ptsContext, quality, dimensions, onProgress=null}) {
  if (!report) throw new Error("Report data is missing");

  let energiaBlocks = [];

try {
  const energiaRes = await getEnergiaTablesByKiinteisto(report.id_kiinteisto);

  if (energiaRes.data?.length > 0) {
    energiaBlocks = energiaRes.data[0]?.data?.blocks || [];
  }

  console.log("ENERGIA BLOCKS FOR PDF:", energiaBlocks);
} catch (err) {
  console.error("Failed to fetch energia tables:", err);
}
  let preview = isPreview

  const pdfAttachments = [];
  const sectionImageCounters = {};
  const tableCounter = { value: 0 };
  

  const reportTitle = report.name;
  let sections = Array.isArray(report.report_sections) ? [...report.report_sections] : [];

  // Extract margin, cover date, and layout settings from coverPageForm block if set
  let coverMarginCm = null;
  let coverDateIso = report?.field_date ?? null;
  let easyReadLayout = false;
  for (const sec of sections) {
    if (!sec.content) continue;
    let parsed;
    try { parsed = typeof sec.content === 'string' ? JSON.parse(sec.content) : sec.content; } catch { continue; }
    for (const block of parsed?.blocks ?? []) {
      if (block.type === 'coverPageForm') {
        if (block.data?.marginCm != null) coverMarginCm = Number(block.data.marginCm);
        // report.field_date is the canonical source; block.data.dateIso is only a fallback
        // for older reports where field_date was never set
        if (!coverDateIso && block.data?.dateIso) coverDateIso = block.data.dateIso;
        if (block.data?.easyReadLayout) easyReadLayout = true;
      }
    }
  }
  const effectiveMarginPt = coverMarginCm != null ? cmToPt(coverMarginCm) : MARGIN_LEFT;
  const effectiveContentWidth = PAGE_WIDTH - 2 * effectiveMarginPt;
  const activeParagraphStyle = easyReadLayout ? easyReadParagraphStyle : paragraphStyle;

  if (Array.isArray(report.section_order) && report.section_order.length > 0) {
    sections.sort((a, b) => report.section_order.indexOf(a.id) - report.section_order.indexOf(b.id));
  }

  // const GREEN_HEADER_MARGIN_BOTTOM = MARGIN_Y/4

  // Paragraph ja list määrittetty täällä koska  lexical tarvitsee jo html conversioon määrittelyn



  const parseContent = (content) => {
    try { return JSON.parse(content); } catch { return { blocks: [] }; }
  };

  // Find the linked PTS project ID from SubsectionBuilderBlock (same logic as DynamicPTSTaulu)
  const linkedPTSProjectId = (() => {
    for (const sec of sections) {
      if (!sec.content) continue;
      const parsed = parseContent(sec.content);
      for (const block of parsed?.blocks ?? []) {
        if (block.type === 'SubsectionBuilderBlock' && block.data?.linkedProjectId)
          return block.data.linkedProjectId;
      }
    }
    return null;
  })();

  // Filter sections hidden by SectionSelectionBlock
  const sectionSelectionBlock = (() => {
    for (const sec of sections) {
      if (!sec.content) continue;
      const parsed = parseContent(sec.content);
      const block = (parsed.blocks ?? []).find(b => b.type === 'SectionSelectionBlock');
      if (block?.data?.hiddenSectionIds?.length) return block;
    }
    return null;
  })();
  if (sectionSelectionBlock) {
    const hiddenIds = new Set(sectionSelectionBlock.data.hiddenSectionIds.map(Number));
    sections = sections.filter(s => !hiddenIds.has(Number(s.id)));
  }
  sections = sections.filter(s => !isSentinelSection(s));
  // Per-section eye-icon toggle in ReportSidebar — excluded from the PDF,
  // but (unlike hiddenSectionIds above) still shown in the sidebar itself.
  sections = sections.filter(s => !parseContent(s.content || '{}').sectionHidden);

  // Preload all measurement projects referenced by blocks into mittausCache
  // so PDF renderers can read them synchronously even on a fresh page load.
  const MEASUREMENT_BLOCK_TYPES = new Set(['PeitepaksuusBlock', 'VetolujuusBlock', 'PoranayteBlock', 'OhuthieBlock', 'KloridipitoisuusBlock']);
  const mittausIdsToLoad = new Set();
  const poranayteIdsToLoad = new Set();
  for (const sec of sections) {
    if (!sec.content) continue;
    let parsed;
    try { parsed = typeof sec.content === 'string' ? JSON.parse(sec.content) : sec.content; } catch { continue; }
    const collectIds = (blocks) => {
      for (const b of blocks ?? []) {
        if (MEASUREMENT_BLOCK_TYPES.has(b.type) && b.data?.mittausProjektiId) {
          mittausIdsToLoad.add(b.data.mittausProjektiId);
        }
        if (b.type === 'PoranayteBlock' && b.data?.mittausProjektiId) {
          poranayteIdsToLoad.add(b.data.mittausProjektiId);
        }
        collectIds(b.data?.blocks);
      }
    };
    collectIds(parsed.blocks);
  }
  await Promise.all([
    ...[...mittausIdsToLoad].map(id =>
      getMittausProjekti(id)
        .then(res => mittausCacheSet(res.data.id, res.data))
        .catch(() => {})
    ),
    // Only fetch naytteet if not already in cache. The UI keeps the cache
    // up to date on every field change, so using it avoids a race where a
    // pending debounced save hasn't reached the DB yet.
    ...[...poranayteIdsToLoad]
      .filter(id => !naytteetListGet(id))
      .map(id =>
        getNaytteetByProjekti(id)
          .then(res => naytteetListSet(id, res.data ?? []))
          .catch(() => {})
      ),
  ]);

  const content = [];
  const liiteContent = [];
  const liiteIndex = []; // { description } entries in insertion order


// --- Remove empty content blocks that would produce empty pages ---
function removeEmptyContentBlocks(contentArray) {
  return contentArray.filter(item => {
    if (!item) return false;

    // If it's a stack, recursively check inner content
    if (item.stack && Array.isArray(item.stack)) {
      item.stack = removeEmptyContentBlocks(item.stack);
      return item.stack.length > 0;
    }

    // If it's a table, image, text, toc, etc. keep it
    if (item.text || item.table || item.image || item.toc || item.canvas || item.columns) {
      return true;
    }

    // Otherwise, remove it (likely empty stack / placeholder)
    return false;
  });
}

  // --- Section & Subsection Numbering ---
  let sectionCounter = 0;
  const subsectionCounters = {};
  let tocInserted = false; // 👈 ADD THIS

  async function imageUrlToBase64(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Failed to convert image to Base64:", url, err);
      return null;
    }
  }
  const allEmpty = (rows, emptyText) =>
    rows.every(r =>
      typeof r[1]?.text === "string" &&
      r[1].text.trim() === emptyText
    );


  const pushSectionHeader = (content, section, sectionIndex, contentWidth = CONTENT_WIDTH) => {
    const title = (section.name || `Osa ${sectionIndex + 1}`).toUpperCase();
    const isCoverPage = title.toLowerCase() === "kansisivu";
    if (isCoverPage) return; // 🧨 Skip adding a header entirely

    sectionCounter++;

    // 🚫 Skip chapter number 2 (reserved for TOC)
    if (sectionCounter === 2 && tocInserted) {
      sectionCounter++;
    }

    subsectionCounters[sectionCounter] = 0;
    const displayNumber = `${sectionCounter} `;

    content.push(
      {
        text: `${displayNumber}\u2003${title}`,
        style: "sectionHeading",
        id: `section-${sectionIndex}`,
        tocItem: { text: `${displayNumber}${title}`, level: 1 },
        tocStyle: { bold: false, fontSize: 12 },
        pageBreak: "before",
        margin: [headerLeftMarginGlobal, -SECTION_TOP_PAD, 0, headingGreenlineMargin],
      },
      {
        canvas: [
          { type: "line", x1: 0, y1: 0, x2: contentWidth-headerLeftMarginGlobal, y2: 0, lineWidth: 1, lineColor: "#198754" },
        ],
        margin: [headerLeftMarginGlobal, 0, 0, bottomMarginItemGlobal],
      }
    );
  };

  const renderBlocks = async (blocks, content, sectionNumber, level = 2, isPreview=preview) => {

    for (const block of blocks) {
      const { type, data } = block;


      switch (type) {

        case "subsection":

          await renderSubsection({
            block,
            content,
            subsectionCounters,
            sectionNumber,
            level,
            renderBlocks,
            reportType: report.type,
          });
          break;

        case "subsection2":
          await renderSubsection2Block({
            data: block.data,
            content,
            renderBlocks,       // pass your recursive render function
            sectionNumber,
            level
          });
          break;

        case "YmparistoBlock":
          renderYmparistoBlock({ block, content, rakennusData, contentWidth: effectiveContentWidth });
          break;
          case "PohjavesiBlock":
          renderPohjavesiBlock({
            block,
            content,
            rakennusData,
            contentWidth: effectiveContentWidth
          });
          break;
          case "TulvariskiBlock":
          renderTulvariskiBlock({
            block,
            content,
            rakennusData,
            contentWidth: effectiveContentWidth
          });
          break;

        case "RadonBlock":
          renderRadonBlock({
            block,
            content,
            rakennusData,
            contentWidth: effectiveContentWidth
          });
          break;
           case "KuntaRadonBlock":
        renderKuntaRadonBlock({
          block,
          content,
          rakennusData,
          contentWidth: effectiveContentWidth
        });
        break;
        case "AsbestBlock":
          renderAsbestBlock({ block, content, rakennusData, paragraphStyle: activeParagraphStyle });
          break;
        case "MaaperaBlock":
          renderMaaperaBlock({
            block,
            content,
            rakennusData,
            contentWidth: effectiveContentWidth
          });
          break;
        case "propertyInfo":
          // console.log("propertyinfo case MERGEDRAKENNUSDATA!,", mergedRakennusData)
          // console.log("propertyinfo case,", rakennusData)
          renderPropertyInfoBlock({ block, content, rakennusData, mergedRakennusData, contentWidth: effectiveContentWidth });
        break;

        case "SignatureBlock":
          await renderSignatureBlock({ data: block.data, content });
          break;

        case "coverPageForm":
          await renderCoverPageForm(block, content, { report, rakennusData, effectiveMarginPt });
          break;

        case "ToimenpideEhdotukset":
          renderToimenpideEhdotukset({ data: block.data, content });
          break;

        case "YhteenvetoToimenpideBlock":
          renderYhteenvetoToimenpideBlock({ content, groupedToimenpiteet });
          break;
        case "SuositeltavatLisatutkimukset":
          renderSuositeltavatLisatutkimukset({
            data: block.data,
            content,
          });
          break;
        case "ToimeksiantajaBlock":
          renderToimeksiantajaBlock({ data: block.data, content });
          break;

        case "SubsectionListBlock":
          renderSubsectionListBlock({ data: block.data, content });
          break;
        case "LampotilaIndeksiBlock":
        renderLampotilaIndeksiBlock({
          data: block.data,
          content
        });
          break;
        case "TeamBlockNimikkeella":
        case "teamBlockYrityksella":
          renderTeamBlock({ data: block.data, content, assignments, report });
          break;

        case "LexicalTextarea":
          renderLexicalTextarea({ data: block.data, content, tableCounter, paragraphStyle: activeParagraphStyle })
          break;

        case "textarea":
          renderTextarea({ 
            data: block.data, 
            content
          });
          break;

        case "RiskBlock":
          renderRiskBlock({
            content,
            riskidata: riskidata,
            contentWidth: effectiveContentWidth,
            reportType: report?.type,
          });
          break;
              case "RiskBlockRakenne":
              case "RiskBlockSahko":
              case "RiskBlockLVI":
          renderKiinteistoRiskReportPdf({
            content,
            data: block.data,
          });
          break;
        case "BulletListBlock":
          renderBulletListBlock({ content, items: block.data?.items });
          break;

        case "MapBlock2":
          // await renderMapBlock2({ content, data: block.data, report });
          await renderMapImage({ content, rakennusData, mergedRakennusData, zoom: 17, blockData: block.data, contentWidth: effectiveContentWidth });
          break;

        case "KokonaisKuntoarvio":
          renderKokonaisKuntoarvio(data, content);
          break;
        case "PtsBlockYhteenveto":
          await renderYhteenvetoPtsBlock({ ptsContext, content, contentWidth: effectiveContentWidth, showAlvZero: block.data?.showAlvZero, hide11thYear: block.data?.hide11thYear });
          break;
        case "PtsBlockTalous":
          await renderTalousBlock({ ptsContext, content, rakennusData, mergedRakennusData, contentWidth: effectiveContentWidth });
          break;
        case "CapexYhteenvetoBlock":
          await renderCapexYhteenveto({ ptsContext, content, rakennusData, mergedRakennusData, contentWidth: effectiveContentWidth, hide11thYear: block.data?.hide11thYear, alviton: block.data?.alviton });
          break;
        case "ToimenpiteetTekstimuodossaBlock":
          renderToimenpiteetTekstimuodossa({ ptsContext, content, rakennusData, mergedRakennusData, contentWidth: effectiveContentWidth, alviton: block.data?.alviton, groupedToimenpiteet });
          break;
        case "PTSBlock":
          await renderPTSBlock(data, content, report, effectiveContentWidth);
          break;

        case "PtsBlockTutkimukset":
          renderTutkimustarpeetTauluBlock({
            ptsContext, content, contentWidth: effectiveContentWidth,
            showAlvZero: block.data?.showAlvZero, hide11thYear: block.data?.hide11thYear
          })
          break;
        case "PtsBlockRakennetekniikka":
          renderTekniikkatauluBlock({
            type: "Rakennetekniikka",
            ptsContext,
            content,
            contentWidth: effectiveContentWidth,
            hideKuntoluokka: block.data?.hideKuntoluokka,
            showAlvZero: block.data?.showAlvZero,
            hide11thYear: block.data?.hide11thYear
          });
          break;

        case "PtsBlockLVI":
          renderTekniikkatauluBlock({
            type: "LVI Järjestelmät",
            ptsContext,
            content,
            contentWidth: effectiveContentWidth,
            hideKuntoluokka: block.data?.hideKuntoluokka,
            showAlvZero: block.data?.showAlvZero,
            hide11thYear: block.data?.hide11thYear
          });
          break;

        case "PtsBlockSahko":
          renderTekniikkatauluBlock({
            type: "Sähköjärjestelmät",
            ptsContext,
            content,
            contentWidth: effectiveContentWidth,
            hideKuntoluokka: block.data?.hideKuntoluokka,
            showAlvZero: block.data?.showAlvZero,
            hide11thYear: block.data?.hide11thYear
          });
          break;


        case "PeitepaksuusBlock":
          renderPeitepaksuusBlock(
            block.data,
            content,
            (mergedRakennusData ?? rakennusData)?.rakennukset_fulls ?? [],
            (mergedRakennusData ?? rakennusData)?.id_kiinteisto ?? null,
            tableCounter,
            effectiveContentWidth
          );
          break;

        case "VetolujuusBlock":
          renderVetolujuusBlock({ block, content, rakennusData: mergedRakennusData ?? rakennusData, tableCounter });
          break;

        case "PoranayteBlock":
          renderPoranayteBlock({ block, content, rakennusData: mergedRakennusData ?? rakennusData, tableCounter });
          break;
        case "OhuthieBlock":
          renderOhuthieBlock({ block, content, rakennusData: mergedRakennusData ?? rakennusData, tableCounter });
          break;

        case "KloridipitoisuusBlock":
          renderKloridipitoisuusBlock({ block, content, tableCounter });
          break;

        case "PeitepaksuusBlockV2":
          await renderPeitepaksuusBlockV2({ block, content, tableCounter, contentWidth: effectiveContentWidth });
          break;

        case "VetolujuusBlockV2":
          await renderVetolujuusBlockV2({ block, content, tableCounter });
          break;

        case "RappausnayteBlockV2":
          await renderRappausnayteBlockV2({ block, content, tableCounter });
          break;

        case "PoranayteBlockV2":
          await renderPoranayteBlockV2({ block, content, tableCounter });
          break;

        case "OhuthieBlockV2":
          await renderOhuthieBlockV2({ block, content, tableCounter });
          break;

        case "KloridipitoisuusBlockV2":
          await renderKloridipitoisuusBlockV2({ block, content, tableCounter });
          break;
          case "MelutasotBlock":
            renderMelutasotBlock({
              block,
              content,
              rakennusData,
              contentWidth: effectiveContentWidth
            });
            break;
          case "WeatherBlock":
            renderWeatherBlock({
              data,
              content,
            });
            break;
          case "EnergiaBlockHeat":
          case "EnergiaBlockWater":
          case "EnergiaBlockElectricity": {

            const indexMap = {
              EnergiaBlockHeat: 0,
              EnergiaBlockWater: 1,
              EnergiaBlockElectricity: 2,
            };

            const energiaData = energiaBlocks[indexMap[type]];

            console.log("PDF energia resolved:", energiaData);

            if (!energiaData) {
              content.push({
                text: "Energiadata puuttuu",
                color: "red",
                margin: [0, 5, 0, 10],
              });
              break;
            }

          const tableContent = [];
renderEnergiaTableBlock({
  data: energiaData,
  content: tableContent,
  contentWidth: effectiveContentWidth,
});

content.push({
  stack: [
    ...tableContent
  ],
  unbreakable: true 
})

            break;
          }
        case "ImageBlock":
          await renderImageBlock({
            data,
            content,
            liiteContent,
            liiteIndex,
            rakennusData,
            sectionImageCounters,
            sectionNumber,
            isPreview,
            showPreviewImages,
            quality,
            dimensions,
            contentWidth: effectiveContentWidth,
          });
          break;
        case "MapImage":
          await renderMapImage({ content, rakennusData, mergedRakennusData, zoom: 17, blockData: block.data, contentWidth: effectiveContentWidth });
          break;

        case "KuntoTable":
          renderKuntoTable({ data: block.data, content });
          break;

        case "MaaraaikaistarkastusTaulukko":
          // Live data, not block.data — this block no longer carries its own
          // frozen snapshot (see MaaraaikaistarkastusTaulukko.jsx's own
          // comment on why: the report view must always match the
          // Taloyhtiökortti tab, not a copy that can drift from it).
          await renderMaaraaikaistarkastusTaulukko({
            kiinteistoId: (mergedRakennusData ?? rakennusData)?.id_kiinteisto,
            content,
            contentWidth: effectiveContentWidth,
          });
          break;

        case "RakennuslupaTaulukko":
          await renderRakennuslupaTaulukko({
            kiinteistoId: (mergedRakennusData ?? rakennusData)?.id_kiinteisto,
            content,
            contentWidth: effectiveContentWidth,
          });
          break;

        case "VaihtoehdotBlock":
          renderVaihtoehdotBlock({ data: block.data, content });
          break;

        case "KuntoarviolauseBlock":
          renderKuntoarviolauseBlock({ data: block.data, content });
          break;

        case "PtsBlockDynamic":
          await renderDynamicPTSBlock({ data: block.data, content, contentWidth: effectiveContentWidth, linkedProjectId: linkedPTSProjectId });
          break;

        case "PdfAttachmentBlock":
          if (block.data?.liiteImages) {
            await renderImageBlock({
              data: { category: 'Liitteet', pdfLayout: 'liite', ...block.data.liiteImages },
              content,
              liiteContent,
              liiteIndex,
              rakennusData,
              sectionImageCounters,
              sectionNumber,
              isPreview,
              showPreviewImages,
              quality,
              dimensions,
              contentWidth: effectiveContentWidth,
            });
          }
          for (const att of block.data?.attachments || []) {
            pdfAttachments.push(att);
          }
          break;

        default: break;
      } // switch
    } // for
  }; // renderBlocks

  // --- Sections ---
  const isRealPdfContent = (items) => items.some(item => {
    if (!item) return false;
    if (typeof item.text === 'string') return item.text.trim().length > 0;
    if (Array.isArray(item.text)) return true;
    if (Array.isArray(item.stack)) return isRealPdfContent(item.stack);
    if (Array.isArray(item.columns)) return item.columns.some(col => isRealPdfContent([col]));
    return true; // tables, images, canvas, toc, ul, etc.
  });

for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex++) {
  const section = sections[sectionIndex];
  const parsed = parseContent(section.content);
  // Per-subsection eye-icon toggle in ReportSidebar — excluded from the
  // PDF, same as sectionHidden above, but scoped to one subsection block
  // rather than the whole section.
  const subsectionHidden = parsed.subsectionHidden || {};
  const blocks = (parsed.blocks || []).filter(b =>
    !((b.type === 'subsection' || b.type === 'subsection2') && subsectionHidden[b.id])
  );

  const sectionTitle = (section.name || `Osa ${sectionIndex + 1}`).toUpperCase();
  const isCoverSection = sectionTitle.toLowerCase() === "kansisivu";
  let sectionRendered = false;

  if (isCoverSection) {
    pushSectionHeader(content, section, sectionIndex, effectiveContentWidth); // no-op for cover
    await renderBlocks(blocks, content, sectionCounter);
    sectionRendered = true;
  } else {
    // Pre-compute what section number would be after pushSectionHeader
    let previewNum = sectionCounter + 1;
    if (previewNum === 2 && tocInserted) previewNum++;

    // Save state that renderBlocks may modify for this section number
    const savedSubCounter = subsectionCounters[previewNum];
    const savedImageCounter = sectionImageCounters[previewNum];
    const savedTableCounter = tableCounter.value;

    const tempContent = [];
    await renderBlocks(blocks, tempContent, previewNum);

    const hasPdfAttachments = blocks.some(b =>
      b.type === 'PdfAttachmentBlock' && b.data?.attachments?.length > 0
    );

    if (isRealPdfContent(tempContent) || hasPdfAttachments) {
      pushSectionHeader(content, section, sectionIndex, effectiveContentWidth); // increments sectionCounter
      content.push(...tempContent);
      sectionRendered = true;
    } else {
      // Restore counters modified during temp render and skip section
      if (savedSubCounter === undefined) delete subsectionCounters[previewNum];
      else subsectionCounters[previewNum] = savedSubCounter;
      if (savedImageCounter === undefined) delete sectionImageCounters[previewNum];
      else sectionImageCounters[previewNum] = savedImageCounter;
      tableCounter.value = savedTableCounter;
    }
  }

  onProgress?.(
    5 + Math.round(((sectionIndex + 1) / sections.length) * 80),
    `Osio ${sectionIndex + 1}/${sections.length}: ${section.name || ""}`
  );

  // If section is "allekirjoitukset", add the logos after the section
  if (sectionRendered && (section.name || "").toLowerCase() === "allekirjoitukset") {
    // Convert static images to Base64 first
    const logoBase64 = await imageUrlToBase64(waativaLogo);
    const suomalainenBase64 = await imageUrlToBase64(Suomalaista_palvelua);

    const logoStack = {
      columns: [
        { 
          image: logoBase64,  // converted Base64
          width: 80, 
          alignment: "right",
          margin: [0, 0, 0, 0]
        },
        { 
          image: suomalainenBase64,  // converted Base64
          width: 50, 
          alignment: "left",
          margin: [0, 15, 0, 0]
        },
      ],
      margin: [0, 0, 0, 0],
    };

    content.push(logoStack);

    const attributionYear = new Date().getFullYear();
    content.push({
      text: `Sisältää Maanmittauslaitoksen Maastokarttarasteri ${attributionYear} ja Kiinteistörekisterikartta ${attributionYear} dataa\nSyke Ryhti (CC BY 4.0)`,
      fontSize: 7,
      color: '#bbbbbb',
      margin: [0, 12, 0, 0],
    });
  }


    // ← Insert TOC after the second section (index 1 if first section is index 0)
    if (sectionIndex === 1) {

      const headerLeftMargin = 0

      tocInserted = true; 
      content.push({
        stack: [
          {
            text: "2 SISÄLLYSLUETTELO",
            style: "sectionHeading",
            margin: [headerLeftMargin, -SECTION_TOP_PAD, 0, headingGreenlineMargin],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: effectiveContentWidth - headerLeftMargin,
                y2: 0,
                lineWidth: 1,
                lineColor: "#198754",
              },
            ],
            margin: [headerLeftMargin, 0, 0, bottomMarginItemGlobal],
          },
          {
            toc: {
              numberStyle: { fontSize: 11, bold: false },
              dotLeader: true,
              linkToDestination: true,
              textMargin: [0, 5, 0, 5],
              tocStyle: (item) => {
                const indent = (item.level - 1) * 15;
                return { margin: [indent, 2, 0, 2], fontSize: 14 - (item.level - 1) };
              },
            },
          },
        ],
        pageBreak: "before", // ← force TOC to start on its own page
      });
    }
  }


  // --- Doc Definition ---
  if (liiteContent.length > 0 || pdfAttachments.length > 0) {
    const makeRow = (num, label) => ({
      columns: [
        { text: `Liite ${num}.`, width: 58, bold: true, font: 'Lato', fontSize: 11 },
        { text: label || '', width: '*', font: 'Lato', fontSize: 11 },
      ],
      columnGap: 8,
      margin: [0, 0, 0, 5],
    });

    // Image liites come first in the PDF (landscape pages), then PDF attachments at the very end
    const imageRows = liiteIndex.map((entry, i) => makeRow(i + 1, entry.label));
    const pdfOffset = liiteIndex.length;
    const pdfRows = pdfAttachments.map((att, i) => {
      att.liiteNum = pdfOffset + i + 1;
      return makeRow(att.liiteNum, att.label || att.name || '');
    });

    content.push({
      stack: [...imageRows, ...pdfRows],
      margin: [0, 8, 0, bottomMarginItemGlobal],
    });
    content.push(...liiteContent);
  }

  // Collapse landscape→portrait resets: if the reset node is last (no following content)
  // or immediately precedes another pageBreak:'before' node, it creates an empty page.
  // Merge it into the next node, or drop it if nothing follows.
  for (let i = content.length - 1; i >= 0; i--) {
    const node = content[i];
    if (node.text === '' && node.pageBreak === 'before' && node.pageOrientation === 'portrait') {
      const next = content[i + 1];
      if (!next) {
        content.splice(i, 1); // last item — drop the empty portrait page
      } else if (next.pageBreak === 'before') {
        next.pageOrientation = 'portrait'; // hand the orientation reset to the next page break
        content.splice(i, 1);
      }
    }
  }

  const hyphenatedContent = content.map(node => hyphenateNode(node));
  const docDefinition = {
    pageSize: "A4",
    pageMargins: [effectiveMarginPt, MARGIN_Y + SECTION_TOP_PAD, effectiveMarginPt, MARGIN_BOTTOM],
    background: (currentPage) => {
      if (currentPage !== 1 || !coverDateIso) return null;
      try {
        return {
          text: `Tarkastuspäivä ${format(new Date(coverDateIso), "dd.MM.yyyy")}`,
          absolutePosition: { x: effectiveMarginPt, y: 738 },
          style: 'paragraph',
        };
      } catch { return null; }
    },
    content: hyphenatedContent,
    
    pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {

   if (
    currentNode.style === "subHeading" ||
    currentNode.style === "boldSubHeading" ||
    currentNode.style === "toimenpideHeading"
  ) {

    const pageHeight = 842;
    const usableHeight = pageHeight - (MARGIN_Y + SECTION_TOP_PAD) - MARGIN_BOTTOM;

    const yPosition = currentNode.startPosition?.verticalRatio * usableHeight;

    const remainingSpace = usableHeight - yPosition;

    // If less than 200pt (~7cm) left → move to next page
    if (remainingSpace < 120) {
      return true;
    }
  }

  return false;
},
    defaultStyle: { font: "JosefinSans", fontSize: fontSizeParagraph },
    styles: {
      coverTitle: {  font: "JosefinSans", fontSize: 26, bold: true, alignment: "center", margin: [0, 200, 0, 10] },
      coverSubtitle: {  font: "JosefinSans", fontSize: 18, alignment: "center", margin: [0, 10, 0, 5] },
      coverDate: {  font: "JosefinSans", fontSize: 12, alignment: "center", margin: [0, 0, 0, 0] },
      heading: {  font: "JosefinSans", fontSize: 18, bold: false, margin: [0, 0, 0, bottomMarginItemGlobal] },
      sectionHeading: {  font: "JosefinSans", fontSize: 18, bold: false, margin: [0, 0, 0, bottomMarginItemGlobal] },
      subHeading: {  
        font: "JosefinSans", 
        fontSize: 14, 
        bold: false, 
        margin: [0, 0, 0, bottomMarginItemGlobal],
        uppercase: true,   
      },
      toimenpideHeading: {
        ...(easyReadLayout ? easyReadParagraphStyle : paragraphStyle),
        margin: [0, bottomMarginItemGlobal, 0, bottomMarginItemGlobal],
      },

      paragraph: {
        ...(easyReadLayout ? easyReadParagraphStyle : paragraphStyle),
      },

      list: {
        ...(easyReadLayout ? { ...listStyle, lineHeight: 1.35 } : listStyle),
      },

      boldSubHeading: { font: "JosefinSans",
        fontSize: 14,
        bold: true,
        margin: [0, 0, 0, bottomMarginItemGlobal],
      },

    },
    // GREEN BANNER ON TOP OF THE PAGE!
    header: (currentPage, pageCount, pageSize) => {
      if (currentPage === 1) return null;
      if (pageSize?.width > pageSize?.height) return null; // landscape = liite page

      const bannerHeight = 30;
      const borderRadius = 0;
      const pageWidth = 595.28; // A4 width in points
      const marginLeft = effectiveMarginPt;
      const marginRight = effectiveMarginPt;
      const bannerBleed = cmToPt(0.15); // extend 0.15 cm beyond content on each side

      return {
        margin: [marginLeft - bannerBleed, GREEN_HEADER_MARGIN_TOP, marginRight - bannerBleed, 0],
        stack: [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageWidth - marginLeft - marginRight + 2 * bannerBleed,
                h: bannerHeight,
                r: borderRadius,
                color: "#04aa00",
              },
            ],
          },
          {
            columns: [
              {
                width: "auto",
                text: new Date().toLocaleDateString("fi-FI"),
                style: "paragraph",
                color: "white",
                bold: true,
                margin: [bannerHeight / 3, bannerHeight / 4, 0, 0],
              },
              {
                width: "*", // ← THIS IS THE KEY
                text: (rakennusData?.kohteen_nimi || "—").toUpperCase(),
                style: "paragraph",
                bold: true,
                color: "white",
                alignment: "right",
                margin: [0, bannerHeight / 4, bannerHeight / 4, 0],
              },
            ],
            margin: [0, -bannerHeight, 0, 0],
          }
        ],
      };
    },
    footer: function (currentPage, pageCount) {
      // Don't show footer on the cover page
      if (currentPage === 1) return null;

      return {
        margin: [effectiveMarginPt, 0, effectiveMarginPt, 20],
        columns: [
          {
            text: `${currentPage}`,
            alignment: "right",
            fontSize: 10,
            color: "#555",
          },
        ],
      };
    },
  };

  return { docDefinition, pdfAttachments };
}